import type { FooterLink } from '../model/types';

export const FOOTER_LINKS: FooterLink[] = [
  {
    name: 'Техническая поддержка',
    link: 'https://lesta.ru/support/ru/products/mk/',
    isExternal: true,
  },
  {
    name: 'Политика конфиденциальности',
    link: 'https://legal.lesta.ru/privacy-policy/',
    isExternal: true,
  },
  {
    name: 'Как загрузить реплей',
    link: '/guide',
    isExternal: false,
  },
];
